import { store } from '@/store'

export default [
  {
    path: '/admin/users',
    name: 'User List',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/UserListView.vue')
  },
  {
    path: '/admin/accounts/:id?',
    name: 'Account List',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AccountListView.vue')
  },
  {
    path: '/admin/registrations/:id?',
    name: 'Registration List',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/RegistrationListView.vue'),
    beforeEnter: async () => {
      try {
        const regApi = await import('@/api/registrations')
        const registrations = await regApi.listRegistrations()
        store.adminRegistrations = registrations
        return true
      } catch {
        return '/apps'
      }
    }
  },
  {
    path: '/admin/telnyx',
    name: 'Telnyx',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/TelnyxView.vue')
  },
  {
    path: '/admin/pending-campaigns',
    redirect: '/admin/telnyx'
  },
  {
    path: '/admin/v2-conversions',
    name: 'V2 Conversions',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/V2ConversionListView.vue')
  },
  {
    path: '/admin/system-health',
    name: 'System Health',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/SystemHealthView.vue')
  },
  {
    path: '/admin/platform-metrics',
    name: 'Platform Metrics',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/PlatformMetricsView.vue')
  }
]
